/**
 * Sign out (every shell): end the server session, then reload. On reload the app asks
 * `/v1/auth/me`, gets no session and shows the sign-in screen. Pure so the order is testable; the
 * web app binds it to `api.logout` and `location.reload` once (apps/web/src/auth/signOut.ts).
 */

export type SignOutDeps = {
  /** Ends the session on the server (`api.logout`). */
  logout: () => Promise<void>;
  /** Restarts the app, which then boots to the sign-in screen (`location.reload`). */
  reload: () => void;
};

/**
 * Reloads only after the server confirmed the sign-out: a failed logout rejects and leaves the
 * app as it is, rather than reloading into a session that is still signed in.
 */
export async function endSession({ logout, reload }: SignOutDeps): Promise<void> {
  await logout();
  reload();
}
